/* Do not change, this code is generated from Golang structs */

import dayjs from 'dayjs';

export enum UserStatus {
    ActiveUser = "active",
}
export enum ApplicationType {
    ATBrowser = "browser",
    ATDesktop = "desktop",
}
export enum EmployeeAuthorizeMethod {
    EAMEmail = "email",
    EAMPassword = "password",
}
export enum IntegrationType {
    ITAzureActiveDirectory = "azureActiveDirectory",
    ITGoogleWorkspace = "googleWorkspace",
}
export enum SoftwareLicensePaymentFrequency {
    SLPFNone = "-",
    SLPFCustom = "custom",
    SLPFDaily = "daily",
    SLPFWeekly = "weekly",
    SLPFMonthly = "monthly",
    SLPFQuarterly = "quarterly",
    SLPFYearly = "yearly",
}
export enum SoftwareLicenseEntitlementsCriteria {
    SLECNone = "-",
    SLECUserBased = "userBased",
    SLECDeviceBased = "deviceBased",
    SLECUserDeviceBased = "userDeviceBased",
}
export enum SoftwareLicensePaymentStatus {
    SLPSVoided = "voided",
    SLPSUnpaid = "unpaid",
    SLPSPaid = "paid",
    SLPSUpcoming = "upcoming",
}
export enum SoftwareLicensePaymentType {
    SLPTManual = "manual",
    SLPTAuto = "auto",
}
export enum SoftwareLicenseSeatActionType {
    SLSATAdd = "add",
    SLSATRemove = "remove",
}
export enum SoftwareLicenseStatus {
    SLStatusActive = "active",
    SLStatusExpired = "expired",
    SLStatusTerminated = "terminated",
    SLStatusNotStarted = "notStarted",
}
export enum SubscriptionPlan {
    SPLNone = "none",
    SPLBasic = "basic",
    SPLPro = "pro",
    SPLBusiness = "business",
}
export enum SubscriptionPeriod {
    SPEMonthly = "monthly",
    SPEYearly = "yearly",
}
export enum ErrKey {
    MainErrKey = "main",
    AgentAuthMiddlewareErrKey = "agent-auth-middleware",
    AuthMiddlewareErrKey = "auth-middleware",
    GuardMiddlewareErrKey = "guard-middleware",
    IsProjectResourceMiddlewareErrKey = "is-project-resource-middleware",
    TaskAuthMiddlewareErrKey = "task-auth-middleware",
    AsyncTaskHandlerErrKey = "async-task-handler",
    AuthHandlerErrKey = "auth-handler",
    ProjectHandlerErrKey = "project-handler",
    UserHandlerErrKey = "user-handler",
    SubscriptionHandlerErrKey = "subscription-handler",
    AgentHandlerErrKey = "agent-handler",
    DepartmentHandlerErrKey = "department-handler",
    EmployeeHandlerErrKey = "employee-handler",
    ApplicationHandlerErrKey = "application-handler",
    DeviceHandlerErrKey = "device-handler",
    UsedApplicationHandlerErrKey = "used-application-handler",
    OverviewHandlerErrKey = "overview-handler",
    VendorHandlerErrKey = "vendor-handler",
    IntegrationHandlerErrKey = "integration-handler",
    SoftwareLicenseHandlerErrKey = "software-license-handler",
    ODMErrKey = "odm",
    UserRepositoryErrKey = "user-repository",
    EmployeeRepositoryErrKey = "employee-repository",
    UsedApplicationRepositoryErrKey = "used-application-repository",
    DeviceRepositoryErrKey = "device-repository",
    ApplicationRepositoryErrKey = "application-repository",
    InstalledApplicationRepositoryErrKey = "installed-application-repository",
    UnhandledApplicationRepositoryErrKey = "unhandled-application-repository",
    VendorRepositoryErrKey = "vendor-repository",
    IntegrationRepositoryErrKey = "integration-repository",
    SoftwareLicenseRepositoryErrKey = "software-license-repository",
    SoftwareLicenseTypeRepositoryErrKey = "software-license-type-repository",
    SoftwareLicenseEntitlementRepositoryErrKey = "software-license-entitlement-repository",
    SoftwareLicenseOptionRepositoryErrKey = "software-license-option-repository",
    SoftwareLicensePaymentRepositoryErrKey = "software-license-payment-repository",
    SoftwareLicenseSeatActionRepositoryErrKey = "software-license-seat-action-repository",
    AuthServiceErrKey = "auth-service",
    CryptoServiceErrKey = "crypto-service",
    StorageServiceErrKey = "storage-service",
    TaskServiceErrKey = "task-service",
    ProjectServiceErrKey = "project-service",
    UserServiceErrKey = "user-service",
    SubscriptionServiceErrKey = "subscription-service",
    MailServiceErrKey = "mail-service",
    MessageBirdServiceErrKey = "messagebird-service",
    EmployeeServiceErrKey = "employee-service",
    UsedApplicationServiceErrKey = "used-application-service",
    VendorServiceErrKey = "vendor-service",
    IntegrationServiceErrKey = "integration-service",
    AzureADServiceErrKey = "azure-ad-service",
    GoogleWorkspaceServiceErrKey = "google-workspace-service",
    SoftwareLicenseServiceErrKey = "software-license-service",
}
export class ApplicationCategory {
    id: string;
    createdAt: dayjs.Dayjs;
    updatedAt: dayjs.Dayjs;
    deletedAt?: dayjs.Dayjs;
    parentId?: string;
    name: string;
    slug: string;
    isActive: boolean;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.id = source["id"];
        this.createdAt = source["createdAt"] ? dayjs(source["createdAt"]) : source["createdAt"];
        this.updatedAt = source["updatedAt"] ? dayjs(source["updatedAt"]) : source["updatedAt"];
        this.deletedAt = source["deletedAt"] ? dayjs(source["deletedAt"]) : source["deletedAt"];
        this.parentId = source["parentId"];
        this.name = source["name"];
        this.slug = source["slug"];
        this.isActive = source["isActive"];
    }
}
export class ApplicationVendor {
    id: string;
    createdAt: dayjs.Dayjs;
    updatedAt: dayjs.Dayjs;
    deletedAt?: dayjs.Dayjs;
    name: string;
    isActive: boolean;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.id = source["id"];
        this.createdAt = source["createdAt"] ? dayjs(source["createdAt"]) : source["createdAt"];
        this.updatedAt = source["updatedAt"] ? dayjs(source["updatedAt"]) : source["updatedAt"];
        this.deletedAt = source["deletedAt"] ? dayjs(source["deletedAt"]) : source["deletedAt"];
        this.name = source["name"];
        this.isActive = source["isActive"];
    }
}
export class ApplicationSignatureMacOS {
    path: string;
    bundleId: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.path = source["path"];
        this.bundleId = source["bundleId"];
    }
}
export class ApplicationSignatureWindows {
    path: string;
    processName: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.path = source["path"];
        this.processName = source["processName"];
    }
}
export class ApplicationSignatureBrowser {
    hostname: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.hostname = source["hostname"];
    }
}
export class ApplicationSignature {
    browser?: ApplicationSignatureBrowser;
    windows?: ApplicationSignatureWindows;
    macOS?: ApplicationSignatureMacOS;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.browser = this.convertValues(source["browser"], ApplicationSignatureBrowser);
        this.windows = this.convertValues(source["windows"], ApplicationSignatureWindows);
        this.macOS = this.convertValues(source["macOS"], ApplicationSignatureMacOS);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class Application {
    id: string;
    createdAt: dayjs.Dayjs;
    updatedAt: dayjs.Dayjs;
    deletedAt?: dayjs.Dayjs;
    vendorId: string;
    categoryId: string;
    type: ApplicationType;
    name: string;
    description?: string;
    minSpecs?: string;
    latestVer?: string;
    icon: string;
    signature: ApplicationSignature;
    isActive: boolean;
    vendor?: ApplicationVendor;
    category?: ApplicationCategory;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.id = source["id"];
        this.createdAt = source["createdAt"] ? dayjs(source["createdAt"]) : source["createdAt"];
        this.updatedAt = source["updatedAt"] ? dayjs(source["updatedAt"]) : source["updatedAt"];
        this.deletedAt = source["deletedAt"] ? dayjs(source["deletedAt"]) : source["deletedAt"];
        this.vendorId = source["vendorId"];
        this.categoryId = source["categoryId"];
        this.type = source["type"];
        this.name = source["name"];
        this.description = source["description"];
        this.minSpecs = source["minSpecs"];
        this.latestVer = source["latestVer"];
        this.icon = source["icon"];
        this.signature = this.convertValues(source["signature"], ApplicationSignature);
        this.isActive = source["isActive"];
        this.vendor = this.convertValues(source["vendor"], ApplicationVendor);
        this.category = this.convertValues(source["category"], ApplicationCategory);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class UserPhoneVerification {
    isVerified: boolean;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.isVerified = source["isVerified"];
    }
}
export class UserUsage {
    projects: number;
    teammates: number;
    employees: number;
    devices: number;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.projects = source["projects"];
        this.teammates = source["teammates"];
        this.employees = source["employees"];
        this.devices = source["devices"];
    }
}
export class UserSubscription {
    plan: SubscriptionPlan;
    period: SubscriptionPeriod;
    quantity: number;
    canceledDate?: dayjs.Dayjs;
    endDate: dayjs.Dayjs;
    hasTrial: boolean;
    hasPastDue: boolean;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.plan = source["plan"];
        this.period = source["period"];
        this.quantity = source["quantity"];
        this.canceledDate = source["canceledDate"] ? dayjs(source["canceledDate"]) : source["canceledDate"];
        this.endDate = source["endDate"] ? dayjs(source["endDate"]) : source["endDate"];
        this.hasTrial = source["hasTrial"];
        this.hasPastDue = source["hasPastDue"];
    }
}
export class User {
    id: string;
    createdAt: dayjs.Dayjs;
    updatedAt: dayjs.Dayjs;
    deletedAt?: dayjs.Dayjs;
    firstName: string;
    lastName: string;
    phone?: string;
    email: string;
    confirmed: boolean;
    blocked: boolean;
    status: UserStatus;
    lastLogin?: dayjs.Dayjs;
    subscription: UserSubscription;
    usage: UserUsage;
    phoneVerification: UserPhoneVerification;
    onboardingDismissed: boolean;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.id = source["id"];
        this.createdAt = source["createdAt"] ? dayjs(source["createdAt"]) : source["createdAt"];
        this.updatedAt = source["updatedAt"] ? dayjs(source["updatedAt"]) : source["updatedAt"];
        this.deletedAt = source["deletedAt"] ? dayjs(source["deletedAt"]) : source["deletedAt"];
        this.firstName = source["firstName"];
        this.lastName = source["lastName"];
        this.phone = source["phone"];
        this.email = source["email"];
        this.confirmed = source["confirmed"];
        this.blocked = source["blocked"];
        this.status = source["status"];
        this.lastLogin = source["lastLogin"] ? dayjs(source["lastLogin"]) : source["lastLogin"];
        this.subscription = this.convertValues(source["subscription"], UserSubscription);
        this.usage = this.convertValues(source["usage"], UserUsage);
        this.phoneVerification = this.convertValues(source["phoneVerification"], UserPhoneVerification);
        this.onboardingDismissed = source["onboardingDismissed"];
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class ProjectInvitedUser {
    email: string;
    date: dayjs.Dayjs;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.email = source["email"];
        this.date = source["date"] ? dayjs(source["date"]) : source["date"];
    }
}
export class Project {
    id: string;
    createdAt: dayjs.Dayjs;
    updatedAt: dayjs.Dayjs;
    deletedAt?: dayjs.Dayjs;
    userId: string;
    teammates?: string[];
    invitedUsers?: ProjectInvitedUser[];
    name: string;
    user?: User;
    teamUsers?: User[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.id = source["id"];
        this.createdAt = source["createdAt"] ? dayjs(source["createdAt"]) : source["createdAt"];
        this.updatedAt = source["updatedAt"] ? dayjs(source["updatedAt"]) : source["updatedAt"];
        this.deletedAt = source["deletedAt"] ? dayjs(source["deletedAt"]) : source["deletedAt"];
        this.userId = source["userId"];
        this.teammates = source["teammates"];
        this.invitedUsers = this.convertValues(source["invitedUsers"], ProjectInvitedUser);
        this.name = source["name"];
        this.user = this.convertValues(source["user"], User);
        this.teamUsers = this.convertValues(source["teamUsers"], User);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}

export class Department {
    id: string;
    createdAt: dayjs.Dayjs;
    updatedAt: dayjs.Dayjs;
    deletedAt?: dayjs.Dayjs;
    projectId: string;
    applicationIds?: string[];
    name: string;
    applications?: Application[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.id = source["id"];
        this.createdAt = source["createdAt"] ? dayjs(source["createdAt"]) : source["createdAt"];
        this.updatedAt = source["updatedAt"] ? dayjs(source["updatedAt"]) : source["updatedAt"];
        this.deletedAt = source["deletedAt"] ? dayjs(source["deletedAt"]) : source["deletedAt"];
        this.projectId = source["projectId"];
        this.applicationIds = source["applicationIds"];
        this.name = source["name"];
        this.applications = this.convertValues(source["applications"], Application);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class DeviceDisk {
    device: string;
    type: string;
    name: string;
    vendor: string;
    size?: number;
    firmwareRevision: string;
    serialNum: string;
    interfaceType: string;
    smartStatus: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.device = source["device"];
        this.type = source["type"];
        this.name = source["name"];
        this.vendor = source["vendor"];
        this.size = source["size"];
        this.firmwareRevision = source["firmwareRevision"];
        this.serialNum = source["serialNum"];
        this.interfaceType = source["interfaceType"];
        this.smartStatus = source["smartStatus"];
    }
}
export class DeviceDisplayResolution {
    x?: number;
    y?: number;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.x = source["x"];
        this.y = source["y"];
    }
}
export class DeviceDisplay {
    vendor: string;
    vendorId: string;
    model: string;
    main?: boolean;
    builtin?: boolean;
    connection: string;
    pixelDepth?: number;
    resolution: DeviceDisplayResolution;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.vendor = source["vendor"];
        this.vendorId = source["vendorId"];
        this.model = source["model"];
        this.main = source["main"];
        this.builtin = source["builtin"];
        this.connection = source["connection"];
        this.pixelDepth = source["pixelDepth"];
        this.resolution = this.convertValues(source["resolution"], DeviceDisplayResolution);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class DeviceGPU {
    vendor: string;
    model: string;
    bus: string;
    vram?: number;
    vramDynamic?: boolean;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.vendor = source["vendor"];
        this.model = source["model"];
        this.bus = source["bus"];
        this.vram = source["vram"];
        this.vramDynamic = source["vramDynamic"];
    }
}
export class DeviceMemoryVoltage {
    configured?: number;
    min?: number;
    max?: number;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.configured = source["configured"];
        this.min = source["min"];
        this.max = source["max"];
    }
}
export class DeviceMemory {
    size?: number;
    bank: string;
    type: string;
    ecc?: boolean;
    clockSpeed?: number;
    formFactor: string;
    manufacturer: string;
    partNum: string;
    serialNum: string;
    voltage: DeviceMemoryVoltage;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.size = source["size"];
        this.bank = source["bank"];
        this.type = source["type"];
        this.ecc = source["ecc"];
        this.clockSpeed = source["clockSpeed"];
        this.formFactor = source["formFactor"];
        this.manufacturer = source["manufacturer"];
        this.partNum = source["partNum"];
        this.serialNum = source["serialNum"];
        this.voltage = this.convertValues(source["voltage"], DeviceMemoryVoltage);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class DeviceCPU {
    manufacturer: string;
    brand: string;
    speed?: number;
    speedMin?: number;
    speedMax?: number;
    cores?: number;
    physicalCores?: number;
    processors?: number;
    socket: string;
    vendor: string;
    family: string;
    model: string;
    stepping: string;
    revision: string;
    flags: string;
    virtualization?: boolean;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.manufacturer = source["manufacturer"];
        this.brand = source["brand"];
        this.speed = source["speed"];
        this.speedMin = source["speedMin"];
        this.speedMax = source["speedMax"];
        this.cores = source["cores"];
        this.physicalCores = source["physicalCores"];
        this.processors = source["processors"];
        this.socket = source["socket"];
        this.vendor = source["vendor"];
        this.family = source["family"];
        this.model = source["model"];
        this.stepping = source["stepping"];
        this.revision = source["revision"];
        this.flags = source["flags"];
        this.virtualization = source["virtualization"];
    }
}
export class DeviceChassis {
    manufacturer: string;
    model: string;
    type: string;
    version: string;
    serial: string;
    assetTag: string;
    sku: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.manufacturer = source["manufacturer"];
        this.model = source["model"];
        this.type = source["type"];
        this.version = source["version"];
        this.serial = source["serial"];
        this.assetTag = source["assetTag"];
        this.sku = source["sku"];
    }
}
export class DeviceBaseboard {
    manufacturer: string;
    model: string;
    version: string;
    serial: string;
    assetTag: string;
    memMax?: number;
    memSlots?: number;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.manufacturer = source["manufacturer"];
        this.model = source["model"];
        this.version = source["version"];
        this.serial = source["serial"];
        this.assetTag = source["assetTag"];
        this.memMax = source["memMax"];
        this.memSlots = source["memSlots"];
    }
}
export class DeviceBIOS {
    vendor: string;
    version: string;
    release: string;
    revision: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.vendor = source["vendor"];
        this.version = source["version"];
        this.release = source["release"];
        this.revision = source["revision"];
    }
}
export class DeviceUUID {
    os: string;
    hardware: string;
    macs?: string[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.os = source["os"];
        this.hardware = source["hardware"];
        this.macs = source["macs"];
    }
}
export class DeviceSystem {
    manufacturer: string;
    model: string;
    version: string;
    serial: string;
    uuid: string;
    sku: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.manufacturer = source["manufacturer"];
        this.model = source["model"];
        this.version = source["version"];
        this.serial = source["serial"];
        this.uuid = source["uuid"];
        this.sku = source["sku"];
    }
}
export class DeviceUser {
    user: string;
    tty: string;
    date: string;
    time: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.user = source["user"];
        this.tty = source["tty"];
        this.date = source["date"];
        this.time = source["time"];
    }
}
export class DeviceOS {
    platform: string;
    distro: string;
    release: string;
    kernel: string;
    arch: string;
    hostname: string;
    fqdn: string;
    build: string;
    servicepack: string;
    uefi?: boolean;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.platform = source["platform"];
        this.distro = source["distro"];
        this.release = source["release"];
        this.kernel = source["kernel"];
        this.arch = source["arch"];
        this.hostname = source["hostname"];
        this.fqdn = source["fqdn"];
        this.build = source["build"];
        this.servicepack = source["servicepack"];
        this.uefi = source["uefi"];
    }
}
export class Device {
    id: string;
    createdAt: dayjs.Dayjs;
    updatedAt: dayjs.Dayjs;
    deletedAt?: dayjs.Dayjs;
    projectId: string;
    employeeId: string;
    deviceId: string;
    name: string;
    agentVersion: string;
    lastSyncAt?: dayjs.Dayjs;
    lastApplicationUsageSyncTimestamp?: dayjs.Dayjs;
    lastResourceUsageSyncTimestamp?: dayjs.Dayjs;
    os: DeviceOS;
    users?: DeviceUser[];
    system: DeviceSystem;
    uuid: DeviceUUID;
    bios: DeviceBIOS;
    baseboard: DeviceBaseboard;
    chassis: DeviceChassis;
    cpu: DeviceCPU;
    memory?: DeviceMemory[];
    gpus?: DeviceGPU[];
    displays?: DeviceDisplay[];
    disks?: DeviceDisk[];
    employee?: Employee;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.id = source["id"];
        this.createdAt = source["createdAt"] ? dayjs(source["createdAt"]) : source["createdAt"];
        this.updatedAt = source["updatedAt"] ? dayjs(source["updatedAt"]) : source["updatedAt"];
        this.deletedAt = source["deletedAt"] ? dayjs(source["deletedAt"]) : source["deletedAt"];
        this.projectId = source["projectId"];
        this.employeeId = source["employeeId"];
        this.deviceId = source["deviceId"];
        this.name = source["name"];
        this.agentVersion = source["agentVersion"];
        this.lastSyncAt = source["lastSyncAt"] ? dayjs(source["lastSyncAt"]) : source["lastSyncAt"];
        this.lastApplicationUsageSyncTimestamp = source["lastApplicationUsageSyncTimestamp"] ? dayjs(source["lastApplicationUsageSyncTimestamp"]) : source["lastApplicationUsageSyncTimestamp"];
        this.lastResourceUsageSyncTimestamp = source["lastResourceUsageSyncTimestamp"] ? dayjs(source["lastResourceUsageSyncTimestamp"]) : source["lastResourceUsageSyncTimestamp"];
        this.os = this.convertValues(source["os"], DeviceOS);
        this.users = this.convertValues(source["users"], DeviceUser);
        this.system = this.convertValues(source["system"], DeviceSystem);
        this.uuid = this.convertValues(source["uuid"], DeviceUUID);
        this.bios = this.convertValues(source["bios"], DeviceBIOS);
        this.baseboard = this.convertValues(source["baseboard"], DeviceBaseboard);
        this.chassis = this.convertValues(source["chassis"], DeviceChassis);
        this.cpu = this.convertValues(source["cpu"], DeviceCPU);
        this.memory = this.convertValues(source["memory"], DeviceMemory);
        this.gpus = this.convertValues(source["gpus"], DeviceGPU);
        this.displays = this.convertValues(source["displays"], DeviceDisplay);
        this.disks = this.convertValues(source["disks"], DeviceDisk);
        this.employee = this.convertValues(source["employee"], Employee);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class EIVGoogleWorkspace {
    id: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.id = source["id"];
    }
}
export class EIVAzureActiveDirectory {
    id: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.id = source["id"];
    }
}
export class EmployeeIntegrationVariables {
    azureActiveDirectory: EIVAzureActiveDirectory;
    googleWorkspace: EIVGoogleWorkspace;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.azureActiveDirectory = this.convertValues(source["azureActiveDirectory"], EIVAzureActiveDirectory);
        this.googleWorkspace = this.convertValues(source["googleWorkspace"], EIVGoogleWorkspace);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class Employee {
    id: string;
    createdAt: dayjs.Dayjs;
    updatedAt: dayjs.Dayjs;
    deletedAt?: dayjs.Dayjs;
    projectId: string;
    departmentIds?: string[];
    email: string;
    firstName: string;
    lastName: string;
    role: string;
    isActive: boolean;
    lastSyncAt?: dayjs.Dayjs;
    authorizeMethod: EmployeeAuthorizeMethod;
    integrationVariables: EmployeeIntegrationVariables;
    departments?: Department[];
    devices?: Device[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.id = source["id"];
        this.createdAt = source["createdAt"] ? dayjs(source["createdAt"]) : source["createdAt"];
        this.updatedAt = source["updatedAt"] ? dayjs(source["updatedAt"]) : source["updatedAt"];
        this.deletedAt = source["deletedAt"] ? dayjs(source["deletedAt"]) : source["deletedAt"];
        this.projectId = source["projectId"];
        this.departmentIds = source["departmentIds"];
        this.email = source["email"];
        this.firstName = source["firstName"];
        this.lastName = source["lastName"];
        this.role = source["role"];
        this.isActive = source["isActive"];
        this.lastSyncAt = source["lastSyncAt"] ? dayjs(source["lastSyncAt"]) : source["lastSyncAt"];
        this.authorizeMethod = source["authorizeMethod"];
        this.integrationVariables = this.convertValues(source["integrationVariables"], EmployeeIntegrationVariables);
        this.departments = this.convertValues(source["departments"], Department);
        this.devices = this.convertValues(source["devices"], Device);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}

export class Browser {
    id: string;
    createdAt: dayjs.Dayjs;
    updatedAt: dayjs.Dayjs;
    deletedAt?: dayjs.Dayjs;
    projectId: string;
    employeeId: string;
    browserId: string;
    name: string;
    extensionVersion: string;
    lastSyncAt?: dayjs.Dayjs;
    lastApplicationUsageSyncTimestamp?: dayjs.Dayjs;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.id = source["id"];
        this.createdAt = source["createdAt"] ? dayjs(source["createdAt"]) : source["createdAt"];
        this.updatedAt = source["updatedAt"] ? dayjs(source["updatedAt"]) : source["updatedAt"];
        this.deletedAt = source["deletedAt"] ? dayjs(source["deletedAt"]) : source["deletedAt"];
        this.projectId = source["projectId"];
        this.employeeId = source["employeeId"];
        this.browserId = source["browserId"];
        this.name = source["name"];
        this.extensionVersion = source["extensionVersion"];
        this.lastSyncAt = source["lastSyncAt"] ? dayjs(source["lastSyncAt"]) : source["lastSyncAt"];
        this.lastApplicationUsageSyncTimestamp = source["lastApplicationUsageSyncTimestamp"] ? dayjs(source["lastApplicationUsageSyncTimestamp"]) : source["lastApplicationUsageSyncTimestamp"];
    }
}
export class UsedApplication {
    id: string;
    createdAt: dayjs.Dayjs;
    updatedAt: dayjs.Dayjs;
    deletedAt?: dayjs.Dayjs;
    employeeId: string;
    applicationId: string;
    deviceId?: string;
    browserId?: string;
    version: string;
    device?: Device;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.id = source["id"];
        this.createdAt = source["createdAt"] ? dayjs(source["createdAt"]) : source["createdAt"];
        this.updatedAt = source["updatedAt"] ? dayjs(source["updatedAt"]) : source["updatedAt"];
        this.deletedAt = source["deletedAt"] ? dayjs(source["deletedAt"]) : source["deletedAt"];
        this.employeeId = source["employeeId"];
        this.applicationId = source["applicationId"];
        this.deviceId = source["deviceId"];
        this.browserId = source["browserId"];
        this.version = source["version"];
        this.device = this.convertValues(source["device"], Device);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class ApplicationUsageStats {
    application?: Application;
    activeCount: number;
    activeTime: number;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.application = this.convertValues(source["application"], Application);
        this.activeCount = source["activeCount"];
        this.activeTime = source["activeTime"];
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class ApplicationUsageChartData {
    date: dayjs.Dayjs;
    activeTimeByApplication?: {[key: string]: number};

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.date = source["date"] ? dayjs(source["date"]) : source["date"];
        this.activeTimeByApplication = source["activeTimeByApplication"];
    }
}
export class Vendor {
    id: string;
    createdAt: dayjs.Dayjs;
    updatedAt: dayjs.Dayjs;
    deletedAt?: dayjs.Dayjs;
    projectId: string;
    name: string;
    description: string;
    website: string;
    address: string;
    email: string;
    phone: string;
    fax: string;
    contactName: string;
    isActive: boolean;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.id = source["id"];
        this.createdAt = source["createdAt"] ? dayjs(source["createdAt"]) : source["createdAt"];
        this.updatedAt = source["updatedAt"] ? dayjs(source["updatedAt"]) : source["updatedAt"];
        this.deletedAt = source["deletedAt"] ? dayjs(source["deletedAt"]) : source["deletedAt"];
        this.projectId = source["projectId"];
        this.name = source["name"];
        this.description = source["description"];
        this.website = source["website"];
        this.address = source["address"];
        this.email = source["email"];
        this.phone = source["phone"];
        this.fax = source["fax"];
        this.contactName = source["contactName"];
        this.isActive = source["isActive"];
    }
}
export class Integration {
    id: string;
    createdAt: dayjs.Dayjs;
    updatedAt: dayjs.Dayjs;
    deletedAt?: dayjs.Dayjs;
    projectId: string;
    type: IntegrationType;
    settings: {[key: string]: any};
    variables: {[key: string]: any};
    isActive: boolean;
    isSyncing: boolean;
    lastSyncAt?: dayjs.Dayjs;
    lastSyncState: string;
    project?: Project;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.id = source["id"];
        this.createdAt = source["createdAt"] ? dayjs(source["createdAt"]) : source["createdAt"];
        this.updatedAt = source["updatedAt"] ? dayjs(source["updatedAt"]) : source["updatedAt"];
        this.deletedAt = source["deletedAt"] ? dayjs(source["deletedAt"]) : source["deletedAt"];
        this.projectId = source["projectId"];
        this.type = source["type"];
        this.settings = source["settings"];
        this.variables = source["variables"];
        this.isActive = source["isActive"];
        this.isSyncing = source["isSyncing"];
        this.lastSyncAt = source["lastSyncAt"] ? dayjs(source["lastSyncAt"]) : source["lastSyncAt"];
        this.lastSyncState = source["lastSyncState"];
        this.project = this.convertValues(source["project"], Project);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class ErrorResponse {
    message: string;
    errors?: string[];
    source?: ErrKey;
    data?: {[key: string]: any};

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.message = source["message"];
        this.errors = source["errors"];
        this.source = source["source"];
        this.data = source["data"];
    }
}
export class SoftwareLicenseEntitlement {
    id: string;
    createdAt: dayjs.Dayjs;
    updatedAt: dayjs.Dayjs;
    deletedAt?: dayjs.Dayjs;
    softwareLicenseId: string;
    employeeId?: string;
    deviceId?: string;
    softwareLicense?: SoftwareLicense;
    employee?: Employee;
    device?: Device;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.id = source["id"];
        this.createdAt = source["createdAt"] ? dayjs(source["createdAt"]) : source["createdAt"];
        this.updatedAt = source["updatedAt"] ? dayjs(source["updatedAt"]) : source["updatedAt"];
        this.deletedAt = source["deletedAt"] ? dayjs(source["deletedAt"]) : source["deletedAt"];
        this.softwareLicenseId = source["softwareLicenseId"];
        this.employeeId = source["employeeId"];
        this.deviceId = source["deviceId"];
        this.softwareLicense = this.convertValues(source["softwareLicense"], SoftwareLicense);
        this.employee = this.convertValues(source["employee"], Employee);
        this.device = this.convertValues(source["device"], Device);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class SoftwareLicenseOption {
    id: string;
    createdAt: dayjs.Dayjs;
    updatedAt: dayjs.Dayjs;
    deletedAt?: dayjs.Dayjs;
    projectId: string;
    name: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.id = source["id"];
        this.createdAt = source["createdAt"] ? dayjs(source["createdAt"]) : source["createdAt"];
        this.updatedAt = source["updatedAt"] ? dayjs(source["updatedAt"]) : source["updatedAt"];
        this.deletedAt = source["deletedAt"] ? dayjs(source["deletedAt"]) : source["deletedAt"];
        this.projectId = source["projectId"];
        this.name = source["name"];
    }
}
export class SoftwareLicenseType {
    id: string;
    createdAt: dayjs.Dayjs;
    updatedAt: dayjs.Dayjs;
    deletedAt?: dayjs.Dayjs;
    projectId: string;
    name: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.id = source["id"];
        this.createdAt = source["createdAt"] ? dayjs(source["createdAt"]) : source["createdAt"];
        this.updatedAt = source["updatedAt"] ? dayjs(source["updatedAt"]) : source["updatedAt"];
        this.deletedAt = source["deletedAt"] ? dayjs(source["deletedAt"]) : source["deletedAt"];
        this.projectId = source["projectId"];
        this.name = source["name"];
    }
}
export class SoftwareLicensePayment {
    id: string;
    createdAt: dayjs.Dayjs;
    updatedAt: dayjs.Dayjs;
    deletedAt?: dayjs.Dayjs;
    softwareLicenseId: string;
    userId?: string;
    type: SoftwareLicensePaymentType;
    status: SoftwareLicensePaymentStatus;
    amount: number;
    note: string;
    voidReason: string;
    paidOn?: dayjs.Dayjs;
    user?: User;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.id = source["id"];
        this.createdAt = source["createdAt"] ? dayjs(source["createdAt"]) : source["createdAt"];
        this.updatedAt = source["updatedAt"] ? dayjs(source["updatedAt"]) : source["updatedAt"];
        this.deletedAt = source["deletedAt"] ? dayjs(source["deletedAt"]) : source["deletedAt"];
        this.softwareLicenseId = source["softwareLicenseId"];
        this.userId = source["userId"];
        this.type = source["type"];
        this.status = source["status"];
        this.amount = source["amount"];
        this.note = source["note"];
        this.voidReason = source["voidReason"];
        this.paidOn = source["paidOn"] ? dayjs(source["paidOn"]) : source["paidOn"];
        this.user = this.convertValues(source["user"], User);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class SoftwareLicenseSeatAction {
    id: string;
    createdAt: dayjs.Dayjs;
    updatedAt: dayjs.Dayjs;
    deletedAt?: dayjs.Dayjs;
    softwareLicenseId: string;
    userId: string;
    vendorId?: string;
    ordererUserId?: string;
    type: SoftwareLicenseSeatActionType;
    quantity: number;
    pricePerSeat: number;
    note: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.id = source["id"];
        this.createdAt = source["createdAt"] ? dayjs(source["createdAt"]) : source["createdAt"];
        this.updatedAt = source["updatedAt"] ? dayjs(source["updatedAt"]) : source["updatedAt"];
        this.deletedAt = source["deletedAt"] ? dayjs(source["deletedAt"]) : source["deletedAt"];
        this.softwareLicenseId = source["softwareLicenseId"];
        this.userId = source["userId"];
        this.vendorId = source["vendorId"];
        this.ordererUserId = source["ordererUserId"];
        this.type = source["type"];
        this.quantity = source["quantity"];
        this.pricePerSeat = source["pricePerSeat"];
        this.note = source["note"];
    }
}
export class SoftwareLicense {
    id: string;
    createdAt: dayjs.Dayjs;
    updatedAt: dayjs.Dayjs;
    deletedAt?: dayjs.Dayjs;
    projectId: string;
    ownerUserIds?: string[];
    applicationId: string;
    vendorId?: string;
    softwareLicenseTypeId?: string;
    softwareLicenseOptionId?: string;
    idNumber: string;
    name: string;
    description: string;
    licenseKey: string;
    startAt: dayjs.Dayjs;
    endAt?: dayjs.Dayjs;
    isRecurringIndefinitely: boolean;
    totalCostPerPayment: number;
    costPerSeat: number;
    paymentFrequency: SoftwareLicensePaymentFrequency;
    customPaymentFrequency: string;
    entitlementsCriteria: SoftwareLicenseEntitlementsCriteria;
    totalSeats: number;
    availableSeats: number;
    availabilityThreshold: number;
    versions?: string[];
    isTerminated: boolean;
    terminatedAt?: dayjs.Dayjs;
    terminateReason: string;
    application?: Application;
    vendor?: Vendor;
    seatActions?: SoftwareLicenseSeatAction[];
    payments?: SoftwareLicensePayment[];
    type?: SoftwareLicenseType;
    option?: SoftwareLicenseOption;
    ownerUsers?: User[];
    entitlements?: SoftwareLicenseEntitlement[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.id = source["id"];
        this.createdAt = source["createdAt"] ? dayjs(source["createdAt"]) : source["createdAt"];
        this.updatedAt = source["updatedAt"] ? dayjs(source["updatedAt"]) : source["updatedAt"];
        this.deletedAt = source["deletedAt"] ? dayjs(source["deletedAt"]) : source["deletedAt"];
        this.projectId = source["projectId"];
        this.ownerUserIds = source["ownerUserIds"];
        this.applicationId = source["applicationId"];
        this.vendorId = source["vendorId"];
        this.softwareLicenseTypeId = source["softwareLicenseTypeId"];
        this.softwareLicenseOptionId = source["softwareLicenseOptionId"];
        this.idNumber = source["idNumber"];
        this.name = source["name"];
        this.description = source["description"];
        this.licenseKey = source["licenseKey"];
        this.startAt = source["startAt"] ? dayjs(source["startAt"]) : source["startAt"];
        this.endAt = source["endAt"] ? dayjs(source["endAt"]) : source["endAt"];
        this.isRecurringIndefinitely = source["isRecurringIndefinitely"];
        this.totalCostPerPayment = source["totalCostPerPayment"];
        this.costPerSeat = source["costPerSeat"];
        this.paymentFrequency = source["paymentFrequency"];
        this.customPaymentFrequency = source["customPaymentFrequency"];
        this.entitlementsCriteria = source["entitlementsCriteria"];
        this.totalSeats = source["totalSeats"];
        this.availableSeats = source["availableSeats"];
        this.availabilityThreshold = source["availabilityThreshold"];
        this.versions = source["versions"];
        this.isTerminated = source["isTerminated"];
        this.terminatedAt = source["terminatedAt"] ? dayjs(source["terminatedAt"]) : source["terminatedAt"];
        this.terminateReason = source["terminateReason"];
        this.application = this.convertValues(source["application"], Application);
        this.vendor = this.convertValues(source["vendor"], Vendor);
        this.seatActions = this.convertValues(source["seatActions"], SoftwareLicenseSeatAction);
        this.payments = this.convertValues(source["payments"], SoftwareLicensePayment);
        this.type = this.convertValues(source["type"], SoftwareLicenseType);
        this.option = this.convertValues(source["option"], SoftwareLicenseOption);
        this.ownerUsers = this.convertValues(source["ownerUsers"], User);
        this.entitlements = this.convertValues(source["entitlements"], SoftwareLicenseEntitlement);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}





export class AgentApplicationMetricsDTOApplicationSignatureMacOS {
    path: string;
    bundleId: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.path = source["path"];
        this.bundleId = source["bundleId"];
    }
}
export class AgentApplicationMetricsDTOApplicationSignatureWindows {
    path: string;
    processName: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.path = source["path"];
        this.processName = source["processName"];
    }
}
export class AgentApplicationMetricsDTOApplicationSignatureBrowser {
    hostname: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.hostname = source["hostname"];
    }
}
export class AgentApplicationMetricsDTOApplicationSignature {
    browser?: AgentApplicationMetricsDTOApplicationSignatureBrowser;
    windows?: AgentApplicationMetricsDTOApplicationSignatureWindows;
    macOS?: AgentApplicationMetricsDTOApplicationSignatureMacOS;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.browser = this.convertValues(source["browser"], AgentApplicationMetricsDTOApplicationSignatureBrowser);
        this.windows = this.convertValues(source["windows"], AgentApplicationMetricsDTOApplicationSignatureWindows);
        this.macOS = this.convertValues(source["macOS"], AgentApplicationMetricsDTOApplicationSignatureMacOS);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class AgentApplicationMetricsDTOApplication {
    date: dayjs.Dayjs;
    checkCount?: number;
    idleAvg?: number;
    activeAvg?: number;
    signature: AgentApplicationMetricsDTOApplicationSignature;
    version: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.date = source["date"] ? dayjs(source["date"]) : source["date"];
        this.checkCount = source["checkCount"];
        this.idleAvg = source["idleAvg"];
        this.activeAvg = source["activeAvg"];
        this.signature = this.convertValues(source["signature"], AgentApplicationMetricsDTOApplicationSignature);
        this.version = source["version"];
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class AgentApplicationMetricsDTOBrowser {
    browserId: string;
    name: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.browserId = source["browserId"];
        this.name = source["name"];
    }
}
export class AgentApplicationMetricsDTODevice {
    deviceId: string;
    name: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.deviceId = source["deviceId"];
        this.name = source["name"];
    }
}
export class AgentApplicationMetricsDTO {
    device?: AgentApplicationMetricsDTODevice;
    browser?: AgentApplicationMetricsDTOBrowser;
    applications: AgentApplicationMetricsDTOApplication[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.device = this.convertValues(source["device"], AgentApplicationMetricsDTODevice);
        this.browser = this.convertValues(source["browser"], AgentApplicationMetricsDTOBrowser);
        this.applications = this.convertValues(source["applications"], AgentApplicationMetricsDTOApplication);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class AgentDeviceInfoDTODeviceDisk {
    device: string;
    type: string;
    name: string;
    vendor: string;
    size?: number;
    firmwareRevision: string;
    serialNum: string;
    interfaceType: string;
    smartStatus: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.device = source["device"];
        this.type = source["type"];
        this.name = source["name"];
        this.vendor = source["vendor"];
        this.size = source["size"];
        this.firmwareRevision = source["firmwareRevision"];
        this.serialNum = source["serialNum"];
        this.interfaceType = source["interfaceType"];
        this.smartStatus = source["smartStatus"];
    }
}
export class AgentDeviceInfoDTODeviceDisplayResolution {
    x?: number;
    y?: number;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.x = source["x"];
        this.y = source["y"];
    }
}
export class AgentDeviceInfoDTODeviceDisplay {
    vendor: string;
    vendorId: string;
    model: string;
    main?: boolean;
    builtin?: boolean;
    connection: string;
    pixelDepth?: number;
    resolution: AgentDeviceInfoDTODeviceDisplayResolution;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.vendor = source["vendor"];
        this.vendorId = source["vendorId"];
        this.model = source["model"];
        this.main = source["main"];
        this.builtin = source["builtin"];
        this.connection = source["connection"];
        this.pixelDepth = source["pixelDepth"];
        this.resolution = this.convertValues(source["resolution"], AgentDeviceInfoDTODeviceDisplayResolution);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class AgentDeviceInfoDTODeviceGPU {
    vendor: string;
    model: string;
    bus: string;
    vram?: number;
    vramDynamic?: boolean;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.vendor = source["vendor"];
        this.model = source["model"];
        this.bus = source["bus"];
        this.vram = source["vram"];
        this.vramDynamic = source["vramDynamic"];
    }
}
export class AgentDeviceInfoDTODeviceMemoryVoltage {
    configured?: number;
    min?: number;
    max?: number;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.configured = source["configured"];
        this.min = source["min"];
        this.max = source["max"];
    }
}
export class AgentDeviceInfoDTODeviceMemory {
    size?: number;
    bank: string;
    type: string;
    ecc?: boolean;
    clockSpeed?: number;
    formFactor: string;
    manufacturer: string;
    partNum: string;
    serialNum: string;
    voltage: AgentDeviceInfoDTODeviceMemoryVoltage;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.size = source["size"];
        this.bank = source["bank"];
        this.type = source["type"];
        this.ecc = source["ecc"];
        this.clockSpeed = source["clockSpeed"];
        this.formFactor = source["formFactor"];
        this.manufacturer = source["manufacturer"];
        this.partNum = source["partNum"];
        this.serialNum = source["serialNum"];
        this.voltage = this.convertValues(source["voltage"], AgentDeviceInfoDTODeviceMemoryVoltage);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class AgentDeviceInfoDTODeviceCPU {
    manufacturer: string;
    brand: string;
    speed?: number;
    speedMin?: number;
    speedMax?: number;
    cores?: number;
    physicalCores?: number;
    processors?: number;
    socket: string;
    vendor: string;
    family: string;
    model: string;
    stepping: string;
    revision: string;
    flags: string;
    virtualization?: boolean;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.manufacturer = source["manufacturer"];
        this.brand = source["brand"];
        this.speed = source["speed"];
        this.speedMin = source["speedMin"];
        this.speedMax = source["speedMax"];
        this.cores = source["cores"];
        this.physicalCores = source["physicalCores"];
        this.processors = source["processors"];
        this.socket = source["socket"];
        this.vendor = source["vendor"];
        this.family = source["family"];
        this.model = source["model"];
        this.stepping = source["stepping"];
        this.revision = source["revision"];
        this.flags = source["flags"];
        this.virtualization = source["virtualization"];
    }
}
export class AgentDeviceInfoDTODeviceChassis {
    manufacturer: string;
    model: string;
    type: string;
    version: string;
    serial: string;
    assetTag: string;
    sku: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.manufacturer = source["manufacturer"];
        this.model = source["model"];
        this.type = source["type"];
        this.version = source["version"];
        this.serial = source["serial"];
        this.assetTag = source["assetTag"];
        this.sku = source["sku"];
    }
}
export class AgentDeviceInfoDTODeviceBaseboard {
    manufacturer: string;
    model: string;
    version: string;
    serial: string;
    assetTag: string;
    memMax?: number;
    memSlots?: number;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.manufacturer = source["manufacturer"];
        this.model = source["model"];
        this.version = source["version"];
        this.serial = source["serial"];
        this.assetTag = source["assetTag"];
        this.memMax = source["memMax"];
        this.memSlots = source["memSlots"];
    }
}
export class AgentDeviceInfoDTODeviceBIOS {
    vendor: string;
    version: string;
    release: string;
    revision: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.vendor = source["vendor"];
        this.version = source["version"];
        this.release = source["release"];
        this.revision = source["revision"];
    }
}
export class AgentDeviceInfoDTODeviceUUID {
    os: string;
    hardware: string;
    macs: string[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.os = source["os"];
        this.hardware = source["hardware"];
        this.macs = source["macs"];
    }
}
export class AgentDeviceInfoDTODeviceSystem {
    manufacturer: string;
    model: string;
    version: string;
    serial: string;
    uuid: string;
    sku: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.manufacturer = source["manufacturer"];
        this.model = source["model"];
        this.version = source["version"];
        this.serial = source["serial"];
        this.uuid = source["uuid"];
        this.sku = source["sku"];
    }
}
export class AgentDeviceInfoDTODeviceUser {
    user: string;
    tty: string;
    date: string;
    time: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.user = source["user"];
        this.tty = source["tty"];
        this.date = source["date"];
        this.time = source["time"];
    }
}
export class AgentDeviceInfoDTODeviceOS {
    platform: string;
    distro: string;
    release: string;
    kernel: string;
    arch: string;
    hostname: string;
    fqdn: string;
    build: string;
    servicepack: string;
    uefi?: boolean;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.platform = source["platform"];
        this.distro = source["distro"];
        this.release = source["release"];
        this.kernel = source["kernel"];
        this.arch = source["arch"];
        this.hostname = source["hostname"];
        this.fqdn = source["fqdn"];
        this.build = source["build"];
        this.servicepack = source["servicepack"];
        this.uefi = source["uefi"];
    }
}
export class AgentDeviceInfoDTODevice {
    deviceId: string;
    name: string;
    os: AgentDeviceInfoDTODeviceOS;
    users: AgentDeviceInfoDTODeviceUser[];
    system: AgentDeviceInfoDTODeviceSystem;
    uuid: AgentDeviceInfoDTODeviceUUID;
    bios: AgentDeviceInfoDTODeviceBIOS;
    baseboard: AgentDeviceInfoDTODeviceBaseboard;
    chassis: AgentDeviceInfoDTODeviceChassis;
    cpu: AgentDeviceInfoDTODeviceCPU;
    memory: AgentDeviceInfoDTODeviceMemory[];
    gpus: AgentDeviceInfoDTODeviceGPU[];
    displays: AgentDeviceInfoDTODeviceDisplay[];
    disks: AgentDeviceInfoDTODeviceDisk[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.deviceId = source["deviceId"];
        this.name = source["name"];
        this.os = this.convertValues(source["os"], AgentDeviceInfoDTODeviceOS);
        this.users = this.convertValues(source["users"], AgentDeviceInfoDTODeviceUser);
        this.system = this.convertValues(source["system"], AgentDeviceInfoDTODeviceSystem);
        this.uuid = this.convertValues(source["uuid"], AgentDeviceInfoDTODeviceUUID);
        this.bios = this.convertValues(source["bios"], AgentDeviceInfoDTODeviceBIOS);
        this.baseboard = this.convertValues(source["baseboard"], AgentDeviceInfoDTODeviceBaseboard);
        this.chassis = this.convertValues(source["chassis"], AgentDeviceInfoDTODeviceChassis);
        this.cpu = this.convertValues(source["cpu"], AgentDeviceInfoDTODeviceCPU);
        this.memory = this.convertValues(source["memory"], AgentDeviceInfoDTODeviceMemory);
        this.gpus = this.convertValues(source["gpus"], AgentDeviceInfoDTODeviceGPU);
        this.displays = this.convertValues(source["displays"], AgentDeviceInfoDTODeviceDisplay);
        this.disks = this.convertValues(source["disks"], AgentDeviceInfoDTODeviceDisk);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class AgentDeviceInfoDTO {
    device?: AgentDeviceInfoDTODevice;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.device = this.convertValues(source["device"], AgentDeviceInfoDTODevice);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class AgentResourceMetricsDTOResourceTopProcess {
    name: string;
    cpuAvg?: number;
    memoryAvg?: number;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.name = source["name"];
        this.cpuAvg = source["cpuAvg"];
        this.memoryAvg = source["memoryAvg"];
    }
}
export class AgentResourceMetricsDTOResource {
    date: dayjs.Dayjs;
    checkCount?: number;
    cpuAvg?: number;
    memoryAvg?: number;
    storageAvg?: number;
    topProcess: AgentResourceMetricsDTOResourceTopProcess[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.date = source["date"] ? dayjs(source["date"]) : source["date"];
        this.checkCount = source["checkCount"];
        this.cpuAvg = source["cpuAvg"];
        this.memoryAvg = source["memoryAvg"];
        this.storageAvg = source["storageAvg"];
        this.topProcess = this.convertValues(source["topProcess"], AgentResourceMetricsDTOResourceTopProcess);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class AgentResourceMetricsDTODevice {
    deviceId: string;
    name: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.deviceId = source["deviceId"];
        this.name = source["name"];
    }
}
export class AgentResourceMetricsDTO {
    device?: AgentResourceMetricsDTODevice;
    resources: AgentResourceMetricsDTOResource[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.device = this.convertValues(source["device"], AgentResourceMetricsDTODevice);
        this.resources = this.convertValues(source["resources"], AgentResourceMetricsDTOResource);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class AgentInstalledApplicationsDTOApplicationSignatureMacOS {
    path: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.path = source["path"];
    }
}
export class AgentInstalledApplicationsDTOApplicationSignatureWindows {
    path: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.path = source["path"];
    }
}
export class AgentInstalledApplicationsDTOApplicationSignature {
    windows?: AgentInstalledApplicationsDTOApplicationSignatureWindows;
    macOS?: AgentInstalledApplicationsDTOApplicationSignatureMacOS;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.windows = this.convertValues(source["windows"], AgentInstalledApplicationsDTOApplicationSignatureWindows);
        this.macOS = this.convertValues(source["macOS"], AgentInstalledApplicationsDTOApplicationSignatureMacOS);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class AgentInstalledApplicationsDTOApplication {
    name: string;
    version: string;
    signature: AgentInstalledApplicationsDTOApplicationSignature;
    installDate?: dayjs.Dayjs;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.name = source["name"];
        this.version = source["version"];
        this.signature = this.convertValues(source["signature"], AgentInstalledApplicationsDTOApplicationSignature);
        this.installDate = source["installDate"] ? dayjs(source["installDate"]) : source["installDate"];
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class AgentInstalledApplicationsDTODevice {
    deviceId: string;
    name: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.deviceId = source["deviceId"];
        this.name = source["name"];
    }
}
export class AgentInstalledApplicationsDTO {
    device: AgentInstalledApplicationsDTODevice;
    installedApplications: AgentInstalledApplicationsDTOApplication[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.device = this.convertValues(source["device"], AgentInstalledApplicationsDTODevice);
        this.installedApplications = this.convertValues(source["installedApplications"], AgentInstalledApplicationsDTOApplication);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class AuthLoginDTO {
    email: string;
    password: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.email = source["email"];
        this.password = source["password"];
    }
}
export class AuthLoginResponseDTO {
    user?: User;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.user = this.convertValues(source["user"], User);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class AuthRegisterDTO {
    companyName: string;
    email: string;
    password: string;
    passwordConfirmation: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.companyName = source["companyName"];
        this.email = source["email"];
        this.password = source["password"];
        this.passwordConfirmation = source["passwordConfirmation"];
    }
}
export class AuthRegisterResponseDTO {
    user?: User;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.user = this.convertValues(source["user"], User);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class AuthConfirmDTO {
    email: string;
    pinCode: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.email = source["email"];
        this.pinCode = source["pinCode"];
    }
}
export class AuthConfirmResponseDTO {
    user?: User;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.user = this.convertValues(source["user"], User);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class AuthResendConfirmationPinCodeDTO {
    email: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.email = source["email"];
    }
}
export class AuthForgotPasswordDTO {
    email: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.email = source["email"];
    }
}
export class AuthResetPasswordDTO {
    email: string;
    pinCode: string;
    password: string;
    passwordConfirmation: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.email = source["email"];
        this.pinCode = source["pinCode"];
        this.password = source["password"];
        this.passwordConfirmation = source["passwordConfirmation"];
    }
}
export class AuthLoginWithGoogleDTO {
    accessToken: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.accessToken = source["accessToken"];
    }
}
export class AuthLoginWithGoogleResponseDTO {
    user?: User;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.user = this.convertValues(source["user"], User);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class AuthRegisterWithGoogleDTO {
    accessToken: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.accessToken = source["accessToken"];
    }
}
export class AuthRegisterWithGoogleResponseDTO {
    user?: User;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.user = this.convertValues(source["user"], User);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class AuthAgentLoginDTO {
    projectId: string;
    email: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.projectId = source["projectId"];
        this.email = source["email"];
    }
}
export class AuthAgentLoginResponseDTO {
    authorizeMethod: EmployeeAuthorizeMethod;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.authorizeMethod = source["authorizeMethod"];
    }
}
export class AgentLoginWithAzureActiveDirectoryDTO {
    domain: string;
    userEmail: string;
    userName: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.domain = source["domain"];
        this.userEmail = source["userEmail"];
        this.userName = source["userName"];
    }
}
export class AgentLoginWithAzureActiveDirectoryResponseDTO {
    employee?: Employee;
    token: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.employee = this.convertValues(source["employee"], Employee);
        this.token = source["token"];
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class AuthAgentConfirmWithEmailDTO {
    projectId: string;
    email: string;
    pinCode: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.projectId = source["projectId"];
        this.email = source["email"];
        this.pinCode = source["pinCode"];
    }
}
export class AuthAgentConfirmWithEmailResponseDTO {
    employee?: Employee;
    token: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.employee = this.convertValues(source["employee"], Employee);
        this.token = source["token"];
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class AuthAgentResendAuthorizationPinCodeDTO {
    projectId: string;
    email: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.projectId = source["projectId"];
        this.email = source["email"];
    }
}
export class AuthAgentConfirmWithPasswordDTO {
    projectId: string;
    email: string;
    password: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.projectId = source["projectId"];
        this.email = source["email"];
        this.password = source["password"];
    }
}
export class AuthAgentConfirmWithPasswordResponseDTO {
    employee?: Employee;
    token: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.employee = this.convertValues(source["employee"], Employee);
        this.token = source["token"];
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class ProjectCreateDTO {
    name: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.name = source["name"];
    }
}
export class ProjectCreateResponseDTO {
    project?: Project;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.project = this.convertValues(source["project"], Project);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class ProjectListResponseDTO {
    projects?: Project[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.projects = this.convertValues(source["projects"], Project);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class ProjectUpdateDTO {
    name: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.name = source["name"];
    }
}
export class ProjectUpdateResponseDTO {
    project?: Project;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.project = this.convertValues(source["project"], Project);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class ProjectGetResponseDTO {
    project?: Project;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.project = this.convertValues(source["project"], Project);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class ProjectInviteUserDTO {
    email: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.email = source["email"];
    }
}
export class ProjectInviteUserResponseDTO {
    project?: Project;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.project = this.convertValues(source["project"], Project);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class UserMeResponseDTO {
    user?: User;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.user = this.convertValues(source["user"], User);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class UserUpdateDTO {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    password: string;
    passwordConfirmation: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.firstName = source["firstName"];
        this.lastName = source["lastName"];
        this.email = source["email"];
        this.phone = source["phone"];
        this.password = source["password"];
        this.passwordConfirmation = source["passwordConfirmation"];
    }
}
export class UserUpdateResponseDTO {
    user?: User;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.user = this.convertValues(source["user"], User);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class UserInvitationsResponseDTO {
    projects: Project[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.projects = this.convertValues(source["projects"], Project);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class UserVerifyPhoneNumberDTO {
    pinCode: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.pinCode = source["pinCode"];
    }
}
export class UserVerifyPhoneNumberResponseDTO {
    user?: User;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.user = this.convertValues(source["user"], User);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class UserOnboardingResponseDTO {
    inviteTeammates: boolean;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.inviteTeammates = source["inviteTeammates"];
    }
}
export class UserOnboardingDismissResponseDTO {
    user?: User;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.user = this.convertValues(source["user"], User);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class SubscriptionUpgradePlanDTO {
    planPeriod: string;
    quantity: number;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.planPeriod = source["planPeriod"];
        this.quantity = source["quantity"];
    }
}
export class SubscriptionUpgradePlanResponseDTO {
    url: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.url = source["url"];
    }
}
export class SubscriptionManageDTO {
    mode: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.mode = source["mode"];
    }
}
export class SubscriptionManageResponseDTO {
    url: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.url = source["url"];
    }
}
export class PlanLimits {
    projects: number;
    teammates: number;
    employees: number;
    appTracking: boolean;
    deviceManagement: boolean;
    browserTracking: boolean;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.projects = source["projects"];
        this.teammates = source["teammates"];
        this.employees = source["employees"];
        this.appTracking = source["appTracking"];
        this.deviceManagement = source["deviceManagement"];
        this.browserTracking = source["browserTracking"];
    }
}
export class Plan {
    plan: SubscriptionPlan;
    name: string;
    monthlyPrice: number;
    yearlyPrice: number;
    minQuantity: number;
    features: string[];
    limits: PlanLimits;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.plan = source["plan"];
        this.name = source["name"];
        this.monthlyPrice = source["monthlyPrice"];
        this.yearlyPrice = source["yearlyPrice"];
        this.minQuantity = source["minQuantity"];
        this.features = source["features"];
        this.limits = this.convertValues(source["limits"], PlanLimits);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class SubscriptionPlanListResponseDTO {
    plans?: Plan[];
    selectablePlanAndPeriods?: {[key in SubscriptionPlan]: SubscriptionPeriod[]};

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.plans = this.convertValues(source["plans"], Plan);
        this.selectablePlanAndPeriods = source["selectablePlanAndPeriods"];
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class DepartmentCreateDTO {
    name: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.name = source["name"];
    }
}
export class DepartmentCreateResponseDTO {
    department?: Department;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.department = this.convertValues(source["department"], Department);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class DepartmentUpdateDTO {
    name: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.name = source["name"];
    }
}
export class DepartmentUpdateResponseDTO {
    department?: Department;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.department = this.convertValues(source["department"], Department);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class DepartmentUpdateApplicationsDTO {
    applicationIds: string[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.applicationIds = source["applicationIds"];
    }
}
export class DepartmentUpdateApplicationsResponseDTO {
    department?: Department;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.department = this.convertValues(source["department"], Department);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class DepartmentGetResponseDTO {
    department?: Department;
    employees?: Employee[];
    mostUsedApplications?: ApplicationUsageStats[];
    usedApplications?: UsedApplication[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.department = this.convertValues(source["department"], Department);
        this.employees = this.convertValues(source["employees"], Employee);
        this.mostUsedApplications = this.convertValues(source["mostUsedApplications"], ApplicationUsageStats);
        this.usedApplications = this.convertValues(source["usedApplications"], UsedApplication);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class DepartmentListResponseDTO {
    departments?: Department[];
    employeeCounts?: {[key: string]: number};
    mostUsedApplications?: {[key: string]: ApplicationUsageStats[]};

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.departments = this.convertValues(source["departments"], Department);
        this.employeeCounts = source["employeeCounts"];
        this.mostUsedApplications = source["mostUsedApplications"];
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class EmployeeCreateDTO {
    departmentIds: string[];
    email: string;
    firstName: string;
    lastName: string;
    role: string;
    authorizeMethod: string;
    agentPassword: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.departmentIds = source["departmentIds"];
        this.email = source["email"];
        this.firstName = source["firstName"];
        this.lastName = source["lastName"];
        this.role = source["role"];
        this.authorizeMethod = source["authorizeMethod"];
        this.agentPassword = source["agentPassword"];
    }
}
export class EmployeeCreateResponseDTO {
    employee?: Employee;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.employee = this.convertValues(source["employee"], Employee);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class EmployeeUpdateDTO {
    departmentIds: string[];
    email: string;
    firstName: string;
    lastName: string;
    role: string;
    isActive?: boolean;
    authorizeMethod: string;
    agentPassword: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.departmentIds = source["departmentIds"];
        this.email = source["email"];
        this.firstName = source["firstName"];
        this.lastName = source["lastName"];
        this.role = source["role"];
        this.isActive = source["isActive"];
        this.authorizeMethod = source["authorizeMethod"];
        this.agentPassword = source["agentPassword"];
    }
}
export class EmployeeUpdateResponseDTO {
    employee?: Employee;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.employee = this.convertValues(source["employee"], Employee);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class EmployeeGetResponseDTO {
    employee?: Employee;
    agentPassword?: string;
    relatedApplications?: Application[];
    relatedApplicationVendors?: ApplicationVendor[];
    relatedApplicationCategories?: ApplicationCategory[];
    mostUsedApplications?: ApplicationUsageStats[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.employee = this.convertValues(source["employee"], Employee);
        this.agentPassword = source["agentPassword"];
        this.relatedApplications = this.convertValues(source["relatedApplications"], Application);
        this.relatedApplicationVendors = this.convertValues(source["relatedApplicationVendors"], ApplicationVendor);
        this.relatedApplicationCategories = this.convertValues(source["relatedApplicationCategories"], ApplicationCategory);
        this.mostUsedApplications = this.convertValues(source["mostUsedApplications"], ApplicationUsageStats);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class EmployeeListResponseDTO {
    employees?: Employee[];
    mostUsedApplications?: {[key: string]: ApplicationUsageStats[]};

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.employees = this.convertValues(source["employees"], Employee);
        this.mostUsedApplications = source["mostUsedApplications"];
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class EmployeeAppUsageMetricsDTO {
    startDate?: dayjs.Dayjs;
    endDate?: dayjs.Dayjs;
    applicationIds: string[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.startDate = source["startDate"] ? dayjs(source["startDate"]) : source["startDate"];
        this.endDate = source["endDate"] ? dayjs(source["endDate"]) : source["endDate"];
        this.applicationIds = source["applicationIds"];
    }
}
export class EmployeeAppUsageMetricsResponseDTO {
    chartData?: ApplicationUsageChartData[];
    applications?: Application[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.chartData = this.convertValues(source["chartData"], ApplicationUsageChartData);
        this.applications = this.convertValues(source["applications"], Application);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class DeviceOSStats {
    os: string;
    count: number;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.os = source["os"];
        this.count = source["count"];
    }
}
export class DeviceManufacturerStats {
    manufacturer: string;
    count: number;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.manufacturer = source["manufacturer"];
        this.count = source["count"];
    }
}
export class DeviceListResponseDTO {
    devices?: Device[];
    manufacturerStats?: DeviceManufacturerStats[];
    osStats?: DeviceOSStats[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.devices = this.convertValues(source["devices"], Device);
        this.manufacturerStats = this.convertValues(source["manufacturerStats"], DeviceManufacturerStats);
        this.osStats = this.convertValues(source["osStats"], DeviceOSStats);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class InstalledApplicationSignatureMacOS {
    path: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.path = source["path"];
    }
}
export class InstalledApplicationSignatureWindows {
    path: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.path = source["path"];
    }
}
export class InstalledApplicationSignature {
    windows?: InstalledApplicationSignatureWindows;
    macOS?: InstalledApplicationSignatureMacOS;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.windows = this.convertValues(source["windows"], InstalledApplicationSignatureWindows);
        this.macOS = this.convertValues(source["macOS"], InstalledApplicationSignatureMacOS);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class InstalledApplication {
    id: string;
    createdAt: dayjs.Dayjs;
    updatedAt: dayjs.Dayjs;
    deletedAt?: dayjs.Dayjs;
    deviceId: string;
    applicationId?: string;
    name: string;
    version: string;
    installDate?: dayjs.Dayjs;
    signature: InstalledApplicationSignature;
    isRemoved: boolean;
    application?: Application;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.id = source["id"];
        this.createdAt = source["createdAt"] ? dayjs(source["createdAt"]) : source["createdAt"];
        this.updatedAt = source["updatedAt"] ? dayjs(source["updatedAt"]) : source["updatedAt"];
        this.deletedAt = source["deletedAt"] ? dayjs(source["deletedAt"]) : source["deletedAt"];
        this.deviceId = source["deviceId"];
        this.applicationId = source["applicationId"];
        this.name = source["name"];
        this.version = source["version"];
        this.installDate = source["installDate"] ? dayjs(source["installDate"]) : source["installDate"];
        this.signature = this.convertValues(source["signature"], InstalledApplicationSignature);
        this.isRemoved = source["isRemoved"];
        this.application = this.convertValues(source["application"], Application);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class DeviceGetResponseDTO {
    device?: Device;
    installedApplications?: InstalledApplication[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.device = this.convertValues(source["device"], Device);
        this.installedApplications = this.convertValues(source["installedApplications"], InstalledApplication);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class DeviceResourceMetricsDTO {
    startDate?: dayjs.Dayjs;
    endDate?: dayjs.Dayjs;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.startDate = source["startDate"] ? dayjs(source["startDate"]) : source["startDate"];
        this.endDate = source["endDate"] ? dayjs(source["endDate"]) : source["endDate"];
    }
}
export class DeviceResourceChartDataTopProcess {
    name: string;
    cpuAvg?: number;
    memoryAvg?: number;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.name = source["name"];
        this.cpuAvg = source["cpuAvg"];
        this.memoryAvg = source["memoryAvg"];
    }
}
export class DeviceResourceChartData {
    date: dayjs.Dayjs;
    cpuAvg?: number;
    memoryAvg?: number;
    storageAvg?: number;
    topProcess?: DeviceResourceChartDataTopProcess[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.date = source["date"] ? dayjs(source["date"]) : source["date"];
        this.cpuAvg = source["cpuAvg"];
        this.memoryAvg = source["memoryAvg"];
        this.storageAvg = source["storageAvg"];
        this.topProcess = this.convertValues(source["topProcess"], DeviceResourceChartDataTopProcess);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class DeviceResourceMetricsResponseDTO {
    chartData?: DeviceResourceChartData[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.chartData = this.convertValues(source["chartData"], DeviceResourceChartData);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class DeviceMetricsDTO {
    startDate?: dayjs.Dayjs;
    endDate?: dayjs.Dayjs;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.startDate = source["startDate"] ? dayjs(source["startDate"]) : source["startDate"];
        this.endDate = source["endDate"] ? dayjs(source["endDate"]) : source["endDate"];
    }
}
export class DeviceStatsForProject {
    device?: Device;
    cpuAvg?: number;
    memoryAvg?: number;
    storageAvg?: number;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.device = this.convertValues(source["device"], Device);
        this.cpuAvg = source["cpuAvg"];
        this.memoryAvg = source["memoryAvg"];
        this.storageAvg = source["storageAvg"];
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class DeviceMetricsResponseDTO {
    deviceStats?: DeviceStatsForProject[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.deviceStats = this.convertValues(source["deviceStats"], DeviceStatsForProject);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class ApplicationListResponseDTO {
    applications?: Application[];
    vendors?: ApplicationVendor[];
    categories?: ApplicationCategory[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.applications = this.convertValues(source["applications"], Application);
        this.vendors = this.convertValues(source["vendors"], ApplicationVendor);
        this.categories = this.convertValues(source["categories"], ApplicationCategory);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class ApplicationUsageStatsForProject {
    application?: Application;
    activeCount: number;
    activeTime: number;
    employeeIds?: string[];
    deviceIds?: string[];
    browserIds?: string[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.application = this.convertValues(source["application"], Application);
        this.activeCount = source["activeCount"];
        this.activeTime = source["activeTime"];
        this.employeeIds = source["employeeIds"];
        this.deviceIds = source["deviceIds"];
        this.browserIds = source["browserIds"];
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class UsedApplicationListResponseDTO {
    applications?: Application[];
    vendors?: ApplicationVendor[];
    categories?: ApplicationCategory[];
    mostUsedApplications?: ApplicationUsageStatsForProject[];
    leastUsedApplications?: ApplicationUsageStatsForProject[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.applications = this.convertValues(source["applications"], Application);
        this.vendors = this.convertValues(source["vendors"], ApplicationVendor);
        this.categories = this.convertValues(source["categories"], ApplicationCategory);
        this.mostUsedApplications = this.convertValues(source["mostUsedApplications"], ApplicationUsageStatsForProject);
        this.leastUsedApplications = this.convertValues(source["leastUsedApplications"], ApplicationUsageStatsForProject);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class UsedApplicationListWithoutStatsResponseDTO {
    applications?: Application[];
    vendors?: ApplicationVendor[];
    categories?: ApplicationCategory[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.applications = this.convertValues(source["applications"], Application);
        this.vendors = this.convertValues(source["vendors"], ApplicationVendor);
        this.categories = this.convertValues(source["categories"], ApplicationCategory);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class ApplicationUsageStatsOfDepartment {
    department?: Department;
    activeCount: number;
    activeTime: number;
    employeeIds?: string[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.department = this.convertValues(source["department"], Department);
        this.activeCount = source["activeCount"];
        this.activeTime = source["activeTime"];
        this.employeeIds = source["employeeIds"];
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class UsedApplicationGetResponseDTO {
    application?: Application;
    usageStatsOfDepartments?: ApplicationUsageStatsOfDepartment[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.application = this.convertValues(source["application"], Application);
        this.usageStatsOfDepartments = this.convertValues(source["usageStatsOfDepartments"], ApplicationUsageStatsOfDepartment);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class UsedApplicationEmployeeMetricsDTO {
    startDate?: dayjs.Dayjs;
    endDate?: dayjs.Dayjs;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.startDate = source["startDate"] ? dayjs(source["startDate"]) : source["startDate"];
        this.endDate = source["endDate"] ? dayjs(source["endDate"]) : source["endDate"];
    }
}
export class ApplicationUsageStatsOfEmployee {
    employee?: Employee;
    versions?: UsedApplication[];
    activeCount: number;
    activeTime: number;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.employee = this.convertValues(source["employee"], Employee);
        this.versions = this.convertValues(source["versions"], UsedApplication);
        this.activeCount = source["activeCount"];
        this.activeTime = source["activeTime"];
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class UsedApplicationEmployeeMetricsResponseDTO {
    usageStatsOfEmployees?: ApplicationUsageStatsOfEmployee[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.usageStatsOfEmployees = this.convertValues(source["usageStatsOfEmployees"], ApplicationUsageStatsOfEmployee);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class UsedApplicationMetricsDTO {
    startDate?: dayjs.Dayjs;
    endDate?: dayjs.Dayjs;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.startDate = source["startDate"] ? dayjs(source["startDate"]) : source["startDate"];
        this.endDate = source["endDate"] ? dayjs(source["endDate"]) : source["endDate"];
    }
}
export class UsedApplicationMetricsResponseDTO {
    appStats?: ApplicationUsageStatsForProject[];
    employees?: Employee[];
    devices?: Device[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.appStats = this.convertValues(source["appStats"], ApplicationUsageStatsForProject);
        this.employees = this.convertValues(source["employees"], Employee);
        this.devices = this.convertValues(source["devices"], Device);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class OverviewGeneralResponseDTO {
    employeeCount: number;
    departmentCount: number;
    applicationCount: number;
    vendorCount: number;
    deviceCount: number;
    activeDeviceCount: number;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.employeeCount = source["employeeCount"];
        this.departmentCount = source["departmentCount"];
        this.applicationCount = source["applicationCount"];
        this.vendorCount = source["vendorCount"];
        this.deviceCount = source["deviceCount"];
        this.activeDeviceCount = source["activeDeviceCount"];
    }
}
export class OverviewApplicationsResponseDTO {
    mostUsedApplications?: ApplicationUsageStatsForProject[];
    leastUsedApplications?: ApplicationUsageStatsForProject[];
    leastUtilizedInstalledApp?: Application;
    leastUtilizedInstalledAppDBC: number;
    leastUtilizedInstalledAppADBC: number;
    leastUtilizedInstalledAppURT: number;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.mostUsedApplications = this.convertValues(source["mostUsedApplications"], ApplicationUsageStatsForProject);
        this.leastUsedApplications = this.convertValues(source["leastUsedApplications"], ApplicationUsageStatsForProject);
        this.leastUtilizedInstalledApp = this.convertValues(source["leastUtilizedInstalledApp"], Application);
        this.leastUtilizedInstalledAppDBC = source["leastUtilizedInstalledAppDBC"];
        this.leastUtilizedInstalledAppADBC = source["leastUtilizedInstalledAppADBC"];
        this.leastUtilizedInstalledAppURT = source["leastUtilizedInstalledAppURT"];
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class OverviewDevicesResponseDTO {
    manufacturerStats?: DeviceManufacturerStats[];
    deviceStats?: DeviceStatsForProject[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.manufacturerStats = this.convertValues(source["manufacturerStats"], DeviceManufacturerStats);
        this.deviceStats = this.convertValues(source["deviceStats"], DeviceStatsForProject);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class VendorListResponseDTO {
    vendors?: Vendor[];
    softwareLicenseSeats?: {[key: string]: number};

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.vendors = this.convertValues(source["vendors"], Vendor);
        this.softwareLicenseSeats = source["softwareLicenseSeats"];
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class VendorCreateDTO {
    name: string;
    description: string;
    website: string;
    address: string;
    email: string;
    phone: string;
    fax: string;
    contactName: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.name = source["name"];
        this.description = source["description"];
        this.website = source["website"];
        this.address = source["address"];
        this.email = source["email"];
        this.phone = source["phone"];
        this.fax = source["fax"];
        this.contactName = source["contactName"];
    }
}
export class VendorCreateResponseDTO {
    vendor?: Vendor;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.vendor = this.convertValues(source["vendor"], Vendor);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class VendorUpdateDTO {
    name: string;
    description: string;
    website: string;
    address: string;
    email: string;
    phone: string;
    fax: string;
    contactName: string;
    isActive?: boolean;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.name = source["name"];
        this.description = source["description"];
        this.website = source["website"];
        this.address = source["address"];
        this.email = source["email"];
        this.phone = source["phone"];
        this.fax = source["fax"];
        this.contactName = source["contactName"];
        this.isActive = source["isActive"];
    }
}
export class VendorUpdateResponseDTO {
    vendor?: Vendor;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.vendor = this.convertValues(source["vendor"], Vendor);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class VendorGetResponseDTO {
    vendor?: Vendor;
    softwareLicenseCount: number;
    softwareLicenseSeats: number;
    softwareLicenseTotalCost: number;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.vendor = this.convertValues(source["vendor"], Vendor);
        this.softwareLicenseCount = source["softwareLicenseCount"];
        this.softwareLicenseSeats = source["softwareLicenseSeats"];
        this.softwareLicenseTotalCost = source["softwareLicenseTotalCost"];
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class IntegrationListResponseDTO {
    integrations?: Integration[];
    oAuthCallbackState: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.integrations = this.convertValues(source["integrations"], Integration);
        this.oAuthCallbackState = source["oAuthCallbackState"];
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class IntegrationUpdateAzureActiveDirectoryDTO {
    domain: string;
    mailDomain: string;
    syncDepartments: boolean;
    syncEmployees: boolean;
    isActive: boolean;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.domain = source["domain"];
        this.mailDomain = source["mailDomain"];
        this.syncDepartments = source["syncDepartments"];
        this.syncEmployees = source["syncEmployees"];
        this.isActive = source["isActive"];
    }
}
export class IntegrationUpdateGoogleWorkspaceDTO {
    syncDepartments: boolean;
    syncEmployees: boolean;
    isActive: boolean;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.syncDepartments = source["syncDepartments"];
        this.syncEmployees = source["syncEmployees"];
        this.isActive = source["isActive"];
    }
}
export class SoftwareLicenseCreateDTO {
    applicationId: string;
    vendorId?: string;
    softwareLicenseTypeId?: string;
    softwareLicenseOptionId?: string;
    ownerUserIds: string[];
    idNumber: string;
    name: string;
    description: string;
    licenseKey: string;
    startAt: dayjs.Dayjs;
    endAt?: dayjs.Dayjs;
    isRecurringIndefinitely: boolean;
    totalCostPerPayment: number;
    paymentFrequency: string;
    customPaymentFrequency: string;
    entitlementsCriteria: string;
    totalSeats: number;
    availabilityThreshold: number;
    versions: string[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.applicationId = source["applicationId"];
        this.vendorId = source["vendorId"];
        this.softwareLicenseTypeId = source["softwareLicenseTypeId"];
        this.softwareLicenseOptionId = source["softwareLicenseOptionId"];
        this.ownerUserIds = source["ownerUserIds"];
        this.idNumber = source["idNumber"];
        this.name = source["name"];
        this.description = source["description"];
        this.licenseKey = source["licenseKey"];
        this.startAt = source["startAt"] ? dayjs(source["startAt"]) : source["startAt"];
        this.endAt = source["endAt"] ? dayjs(source["endAt"]) : source["endAt"];
        this.isRecurringIndefinitely = source["isRecurringIndefinitely"];
        this.totalCostPerPayment = source["totalCostPerPayment"];
        this.paymentFrequency = source["paymentFrequency"];
        this.customPaymentFrequency = source["customPaymentFrequency"];
        this.entitlementsCriteria = source["entitlementsCriteria"];
        this.totalSeats = source["totalSeats"];
        this.availabilityThreshold = source["availabilityThreshold"];
        this.versions = source["versions"];
    }
}
export class SoftwareLicenseCreateResponseDTO {
    license?: SoftwareLicense;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.license = this.convertValues(source["license"], SoftwareLicense);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class SoftwareLicenseUpdateDTO {
    vendorId?: string;
    softwareLicenseTypeId?: string;
    softwareLicenseOptionId?: string;
    ownerUserIds: string[];
    idNumber: string;
    name: string;
    description: string;
    licenseKey: string;
    startAt: dayjs.Dayjs;
    endAt?: dayjs.Dayjs;
    isRecurringIndefinitely: boolean;
    totalCostPerPayment: number;
    paymentFrequency: string;
    customPaymentFrequency: string;
    availabilityThreshold: number;
    versions: string[];
    isTerminated: boolean;
    terminatedAt?: dayjs.Dayjs;
    terminateReason: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.vendorId = source["vendorId"];
        this.softwareLicenseTypeId = source["softwareLicenseTypeId"];
        this.softwareLicenseOptionId = source["softwareLicenseOptionId"];
        this.ownerUserIds = source["ownerUserIds"];
        this.idNumber = source["idNumber"];
        this.name = source["name"];
        this.description = source["description"];
        this.licenseKey = source["licenseKey"];
        this.startAt = source["startAt"] ? dayjs(source["startAt"]) : source["startAt"];
        this.endAt = source["endAt"] ? dayjs(source["endAt"]) : source["endAt"];
        this.isRecurringIndefinitely = source["isRecurringIndefinitely"];
        this.totalCostPerPayment = source["totalCostPerPayment"];
        this.paymentFrequency = source["paymentFrequency"];
        this.customPaymentFrequency = source["customPaymentFrequency"];
        this.availabilityThreshold = source["availabilityThreshold"];
        this.versions = source["versions"];
        this.isTerminated = source["isTerminated"];
        this.terminatedAt = source["terminatedAt"] ? dayjs(source["terminatedAt"]) : source["terminatedAt"];
        this.terminateReason = source["terminateReason"];
    }
}
export class SoftwareLicenseUpdateResponseDTO {
    license?: SoftwareLicense;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.license = this.convertValues(source["license"], SoftwareLicense);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class SoftwareLicenseTerminateDTO {
    terminateReason: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.terminateReason = source["terminateReason"];
    }
}
export class SoftwareLicenseGetResponseDTO {
    license?: SoftwareLicense;
    expireDuration: string;
    nextPaymentDate?: dayjs.Dayjs;
    status: SoftwareLicenseStatus;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.license = this.convertValues(source["license"], SoftwareLicense);
        this.expireDuration = source["expireDuration"];
        this.nextPaymentDate = source["nextPaymentDate"] ? dayjs(source["nextPaymentDate"]) : source["nextPaymentDate"];
        this.status = source["status"];
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class SoftwareLicenseListDTO {
    vendorIds: string[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.vendorIds = source["vendorIds"];
    }
}
export class SoftwareLicenseListResponseDTO {
    licenses?: SoftwareLicense[];
    expireDurations?: {[key: string]: string};
    nextPaymentDates?: {[key: string]: dayjs.Dayjs | null};
    statuses?: {[key: string]: SoftwareLicenseStatus};

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.licenses = this.convertValues(source["licenses"], SoftwareLicense);
        this.expireDurations = source["expireDurations"];
        this.nextPaymentDates = source["nextPaymentDates"] ? Object.fromEntries(Object.entries(source["nextPaymentDates"]).map(([k, v]) => [k, v ? dayjs(v as string) : null])) : source["nextPaymentDates"];
        this.statuses = source["statuses"];
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class SoftwareLicenseOptionCreateDTO {
    name: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.name = source["name"];
    }
}
export class SoftwareLicenseOptionCreateResponseDTO {
    option?: SoftwareLicenseOption;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.option = this.convertValues(source["option"], SoftwareLicenseOption);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class SoftwareLicenseOptionUpdateDTO {
    name: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.name = source["name"];
    }
}
export class SoftwareLicenseOptionUpdateResponseDTO {
    option?: SoftwareLicenseOption;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.option = this.convertValues(source["option"], SoftwareLicenseOption);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class SoftwareLicenseOptionListResponseDTO {
    options?: SoftwareLicenseOption[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.options = this.convertValues(source["options"], SoftwareLicenseOption);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class SoftwareLicenseTypeCreateDTO {
    name: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.name = source["name"];
    }
}
export class SoftwareLicenseTypeCreateResponseDTO {
    type?: SoftwareLicenseType;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.type = this.convertValues(source["type"], SoftwareLicenseType);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class SoftwareLicenseTypeUpdateDTO {
    name: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.name = source["name"];
    }
}
export class SoftwareLicenseTypeUpdateResponseDTO {
    type?: SoftwareLicenseType;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.type = this.convertValues(source["type"], SoftwareLicenseType);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class SoftwareLicenseTypeListResponseDTO {
    types?: SoftwareLicenseType[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.types = this.convertValues(source["types"], SoftwareLicenseType);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class SoftwareLicenseEntitlementCreateDTO {
    employeeIds: string[];
    deviceIds: string[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.employeeIds = source["employeeIds"];
        this.deviceIds = source["deviceIds"];
    }
}
export class SoftwareLicenseEntitlementCreateResponseDTO {
    entitlements: SoftwareLicenseEntitlement[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.entitlements = this.convertValues(source["entitlements"], SoftwareLicenseEntitlement);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class SoftwareLicenseEntitlementListResponseDTO {
    entitlements?: SoftwareLicenseEntitlement[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.entitlements = this.convertValues(source["entitlements"], SoftwareLicenseEntitlement);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class SoftwareLicenseEntitlementDeleteDTO {
    entitlementIds: string[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.entitlementIds = source["entitlementIds"];
    }
}
export class SoftwareLicensePaymentCreateDTO {
    amount: number;
    paidOn?: dayjs.Dayjs;
    note: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.amount = source["amount"];
        this.paidOn = source["paidOn"] ? dayjs(source["paidOn"]) : source["paidOn"];
        this.note = source["note"];
    }
}
export class SoftwareLicensePaymentCreateResponseDTO {
    payment?: SoftwareLicensePayment;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.payment = this.convertValues(source["payment"], SoftwareLicensePayment);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class SoftwareLicensePaymentListResponseDTO {
    payments?: SoftwareLicensePayment[];

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.payments = this.convertValues(source["payments"], SoftwareLicensePayment);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class SoftwareLicensePaymentVoidDTO {
    voidReason: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.voidReason = source["voidReason"];
    }
}
export class SoftwareLicensePaymentVoidResponseDTO {
    payment?: SoftwareLicensePayment;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.payment = this.convertValues(source["payment"], SoftwareLicensePayment);
    }

	convertValues(a: any, classs: any, asMap: boolean = false): any {
	    if (!a) {
	        return a;
	    }
	    if (a.slice) {
	        return (a as any[]).map(elem => this.convertValues(elem, classs));
	    } else if ("object" === typeof a) {
	        if (asMap) {
	            for (const key of Object.keys(a)) {
	                a[key] = new classs(a[key]);
	            }
	            return a;
	        }
	        return new classs(a);
	    }
	    return a;
	}
}
export class SoftwareLicenseSeatActionAddDTO {
    ordererUserId: string;
    vendorId?: string;
    quantity: number;
    pricePerSeat: number;
    note: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.ordererUserId = source["ordererUserId"];
        this.vendorId = source["vendorId"];
        this.quantity = source["quantity"];
        this.pricePerSeat = source["pricePerSeat"];
        this.note = source["note"];
    }
}
export class SoftwareLicenseSeatActionRemoveDTO {
    quantity: number;
    pricePerSeat: number;
    note: string;

    constructor(source: any = {}) {
        if ('string' === typeof source) source = JSON.parse(source);
        this.quantity = source["quantity"];
        this.pricePerSeat = source["pricePerSeat"];
        this.note = source["note"];
    }
}